module.exports = __webpack_public_path__ + "images/category_lp/watch/reason1@2x_7bffe24ac641c8b661f6b0a7d0899fb4.png";